/**
 * @generated SignedSource<<0c7de2a101428034abdf36dae05e4f7e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DesignAdaptAlghoritm = "FIT_WITH_BACKGROUND" | "NONE" | "PERCENTAGE";
export type DesignItemTagTypes = "NONE" | "SYNC_COLORS" | "TEAMWEAR";
export type MoqRulesType = "PRODUCT" | "VARIANT";
import { FragmentRefs } from "relay-runtime";
export type composerQueriesTemplateDesign$data = {
  readonly adaptItemsToVariants: DesignAdaptAlghoritm;
  readonly additionalAttributes: ReadonlyArray<{
    readonly metadata: ReadonlyArray<{
      readonly key: string;
      readonly value: string;
    }> | null;
    readonly name: string | null;
    readonly price: number | null;
    readonly value: string | null;
  } | null> | null;
  readonly areas: ReadonlyArray<{
    readonly areaID: number;
    readonly colorID: number;
    readonly modelID: number;
    readonly printTypeID: number;
    readonly sideID: number;
  } | null> | null;
  readonly areasGrids: ReadonlyArray<{
    readonly areaID: number;
    readonly colorID: number;
    readonly gridID: number;
    readonly modelID: number;
    readonly sideID: number;
  } | null> | null;
  readonly cameraScreenshots: ReadonlyArray<{
    readonly cameraLocationID: any;
    readonly cameraName: string | null;
    readonly fileObjectID: number;
    readonly modificationID: any | null;
    readonly sideID: number | null;
    readonly url: string | null;
  } | null> | null;
  readonly canAddImage: boolean;
  readonly canAddShape: boolean;
  readonly canAddText: boolean;
  readonly canChangeSvgColors: boolean;
  readonly canMaskImages: boolean;
  readonly canvasRotation: ReadonlyArray<{
    readonly degrees: number;
    readonly sideID: number;
  } | null> | null;
  readonly categories: ReadonlyArray<{
    readonly categoryID: number;
    readonly name: string | null;
  } | null> | null;
  readonly clientPreviews: ReadonlyArray<{
    readonly fileObjectID: number;
    readonly modificationID: any | null;
    readonly name: string | null;
    readonly sideID: number;
    readonly url: string | null;
  } | null> | null;
  readonly colors: ReadonlyArray<{
    readonly colorID: number;
    readonly isDefault: boolean;
    readonly name: string | null;
  } | null> | null;
  readonly compositionDocID: string | null;
  readonly compositionID: number;
  readonly compoundKey: string | null;
  readonly createdBy: number;
  readonly createdOn: string | null;
  readonly currentModificationID: any | null;
  readonly customerCode: string | null;
  readonly customerID: number;
  readonly description: string | null;
  readonly designID: number;
  readonly designItems: ReadonlyArray<{
    readonly applyImagePriceForQuantity: boolean | null;
    readonly areas: ReadonlyArray<{
      readonly areaID: number;
      readonly colorID: number;
      readonly id: string | null;
      readonly modelID: number;
      readonly sideID: number;
    } | null> | null;
    readonly colorMappings: ReadonlyArray<{
      readonly dest: string | null;
      readonly src: string | null;
    } | null> | null;
    readonly colors: ReadonlyArray<{
      readonly colorCode: string | null;
      readonly colorID: number;
      readonly imageID: number;
      readonly key: string | null;
    } | null> | null;
    readonly constraints: {
      readonly canAddMask: boolean;
      readonly canChangeAdaptText: boolean;
      readonly canChangeFontColor: boolean;
      readonly canChangeFontFamily: boolean;
      readonly canChangeFontItalic: boolean;
      readonly canChangeFontSize: boolean;
      readonly canChangeFontWeight: boolean;
      readonly canChangeJustification: boolean;
      readonly canChangeLetterSpacing: boolean;
      readonly canChangeLineSpacing: boolean;
      readonly canChangeMaskStrokeColor: boolean;
      readonly canChangeMaskStrokeWidth: boolean;
      readonly canChangeShadowAngle: boolean;
      readonly canChangeShadowBlur: boolean;
      readonly canChangeShadowColor: boolean;
      readonly canChangeShadowDistance: boolean;
      readonly canChangeShapeFillColor: boolean;
      readonly canChangeShapeStrokeColor: boolean;
      readonly canChangeShapeStrokeWidth: boolean;
      readonly canChangeSvgColors: boolean;
      readonly canChangeTextBoxMode: boolean;
      readonly canChangeTextPathMode: boolean;
      readonly canChangeTextStrokeColor: boolean | null;
      readonly canChangeTextStrokeWidth: boolean | null;
      readonly canChangeVerticalAlignment: boolean;
      readonly canDelete: boolean;
      readonly canDeleteMask: boolean;
      readonly canDeleteShapeFilling: boolean;
      readonly canEdit: boolean;
      readonly canEditFilledShape: boolean;
      readonly canEditMask: boolean;
      readonly canEditMaskedImage: boolean;
      readonly canEditShapeFilling: boolean;
      readonly canFillShape: boolean;
      readonly canMove: boolean;
      readonly canReplaceMask: boolean;
      readonly canReplaceShapeFilling: boolean;
      readonly canResize: boolean;
      readonly canResizeTextBox: boolean;
      readonly canRotate: boolean;
      readonly canStretch: boolean | null;
      readonly canSyncAlignment: boolean;
      readonly canSyncContent: boolean;
      readonly canSyncCurved: boolean;
      readonly canSyncFontColor: boolean;
      readonly canSyncFontFamily: boolean;
      readonly canSyncFontStyle: boolean;
      readonly canSyncTransforms: boolean;
      readonly canTransform: boolean;
      readonly canWrapTextOnAdaptText: boolean;
      readonly isAlwaysOnBottom: boolean;
      readonly isAlwaysOnTop: boolean;
      readonly isPrintable: boolean;
      readonly itemID: number;
      readonly keepInPreview: boolean;
      readonly keepNrChars: boolean;
      readonly mandatoryToEdit: boolean;
      readonly maxFontSize: number | null;
      readonly maxLetterSpacing: number | null;
      readonly maxLineSpacing: number | null;
      readonly maxNrChars: number;
      readonly maxShadowAngle: number | null;
      readonly maxShadowBlur: number | null;
      readonly maxShadowDistance: number | null;
      readonly maxTextStrokeWidth: number | null;
      readonly minFontSize: number | null;
      readonly minLetterSpacing: number | null;
      readonly minLineSpacing: number | null;
      readonly minNrChars: number;
      readonly minShadowAngle: number | null;
      readonly minShadowBlur: number | null;
      readonly minShadowDistance: number | null;
      readonly minTextStrokeWidth: number | null;
      readonly paddingString: string | null;
      readonly paddingTypeID: number;
      readonly toUppercase: boolean;
    } | null;
    readonly defaultLCID: number;
    readonly designItemTagType: DesignItemTagTypes;
    readonly fillGradientSettings: {
      readonly centerX: number | null;
      readonly centerY: number | null;
      readonly gradientColors: ReadonlyArray<string | null> | null;
      readonly gradientStops: ReadonlyArray<number> | null;
      readonly radial: boolean;
      readonly radius: number | null;
      readonly rotation: number | null;
    } | null;
    readonly fillImageSettings: {
      readonly horizontalFlip: boolean;
      readonly imageID: number;
      readonly leftPosition: number;
      readonly rotation: number;
      readonly scaling: number;
      readonly scalingX: number;
      readonly scalingY: number;
      readonly syncRatio: boolean;
      readonly topPosition: number;
      readonly verticalFlip: boolean;
    } | null;
    readonly imageCustomerCode: string | null;
    readonly imageCustomerID: number;
    readonly imageDpiX: number;
    readonly imageDpiY: number;
    readonly imageFileSize: number;
    readonly imageFormat: string | null;
    readonly imageHeight: number;
    readonly imageID: number;
    readonly imageIsMulticolor: boolean;
    readonly imagePreferredHeight: number | null;
    readonly imagePreferredWidth: number | null;
    readonly imagePrice: number;
    readonly imageSellerID: number;
    readonly imageType: string | null;
    readonly imageVisitorCode: string | null;
    readonly imageVisitorID: number;
    readonly imageWidth: number;
    readonly index: number;
    readonly itemColors: ReadonlyArray<string | null> | null;
    readonly itemGuid: string | null;
    readonly itemID: number;
    readonly json: string | null;
    readonly name: string | null;
    readonly overridePreview: string | null;
    readonly patternSettings: {
      readonly bounds: ReadonlyArray<number> | null;
      readonly flipX: boolean;
      readonly flipY: boolean;
      readonly offsetType: number;
      readonly offsetX: number;
      readonly offsetY: number;
      readonly presetID: number;
      readonly repeatX: boolean;
      readonly repeatY: boolean;
      readonly spacingX: number;
      readonly spacingY: number;
    } | null;
    readonly providerImageID: string | null;
    readonly shape: {
      readonly isMask: boolean;
      readonly itemID: number;
      readonly shapeID: number;
    } | null;
    readonly svg: string | null;
    readonly syncGuid: string | null;
    readonly tag: string | null;
    readonly textArt: {
      readonly config: {
        readonly angleValue: number;
        readonly curveValue: number;
        readonly intensB: number;
        readonly intensT: number;
        readonly isBottom: boolean;
        readonly isBridge: boolean;
        readonly isMiddle: boolean;
        readonly isTop: boolean;
        readonly isTriangle: boolean;
      } | null;
      readonly fontFaceID: number;
      readonly fontFamilyID: number;
      readonly itemID: number;
      readonly text: string | null;
      readonly textArtTypeID: number;
    } | null;
  } | null> | null;
  readonly designTempPreviews: ReadonlyArray<{
    readonly designTempPreviewID: number;
    readonly fileObjectID: number;
    readonly modificationID: any;
    readonly url: string | null;
  } | null> | null;
  readonly designVariantCaches: ReadonlyArray<{
    readonly colorID: number;
    readonly designFileObjectID: number;
    readonly previewFileObjectID: number;
    readonly previewUrl: string | null;
  } | null> | null;
  readonly disableSellerImages: boolean | null;
  readonly docID: string | null;
  readonly elementsDescs: ReadonlyArray<{
    readonly elements: ReadonlyArray<{
      readonly image: {
        readonly imageID: number | null;
      } | null;
      readonly shape: {
        readonly shapeID: number | null;
      } | null;
      readonly tag: string | null;
      readonly text: {
        readonly adaptText: boolean | null;
        readonly content: string | null;
        readonly fillColor: string | null;
        readonly fontFamily: string | null;
        readonly fontSize: number | null;
        readonly fontStretch: string | null;
        readonly fontStyle: string | null;
        readonly fontWeight: string | null;
        readonly justification: string | null;
        readonly letterSpacing: number | null;
        readonly lineSpacing: number | null;
        readonly shadowAngle: number | null;
        readonly shadowBlur: number | null;
        readonly shadowColor: string | null;
        readonly shadowDistance: number | null;
        readonly strokeColor: string | null;
        readonly strokeWidth: string | null;
        readonly verticalAlignment: string | null;
      } | null;
      readonly textArt: {
        readonly content: string | null;
      } | null;
    } | null> | null;
    readonly id: string | null;
  } | null> | null;
  readonly filterCode: string | null;
  readonly finalPrice: number;
  readonly hasSyncEnabled: boolean;
  readonly id: string;
  readonly interfaceID: number | null;
  readonly isDeleted: boolean;
  readonly isDraft: boolean;
  readonly isLibrary: boolean;
  readonly isTemplate: boolean;
  readonly marketPlaceOrderID: number | null;
  readonly maxNrImages: number | null;
  readonly maxNrShapes: number | null;
  readonly maxNrTexts: number | null;
  readonly modelCode: string | null;
  readonly modelID: number;
  readonly modelImageBasePrice: number;
  readonly modelName: string | null;
  readonly modelPrice: number;
  readonly modelPriceDeltaPerc: number;
  readonly modelPriceDeltaValue: number;
  readonly modelTextBasePrice: number;
  readonly modifications: ReadonlyArray<{
    readonly designElementsDescID: string | null;
    readonly modelColorID: number;
    readonly modificationID: any;
    readonly variantNotMatched: boolean;
  } | null> | null;
  readonly modifiedBy: number;
  readonly modifiedOn: string | null;
  readonly moqs: ReadonlyArray<{
    readonly minQuantity: number;
    readonly modificationID: any | null;
    readonly quantityPackages: ReadonlyArray<number> | null;
    readonly quantityStep: number | null;
    readonly rulesType: MoqRulesType;
  } | null> | null;
  readonly name: string | null;
  readonly options: ReadonlyArray<{
    readonly colorID: number;
    readonly columns: number | null;
    readonly height: number | null;
    readonly id: number;
    readonly rows: number | null;
    readonly sideID: number | null;
    readonly width: number | null;
  } | null> | null;
  readonly parentTemplateId: number | null;
  readonly pdSettings: number;
  readonly pricingModelID: number;
  readonly printTypeID: number;
  readonly salesChannelID: number;
  readonly sides: ReadonlyArray<{
    readonly canAddImage: boolean;
    readonly canAddShape: boolean;
    readonly canAddText: boolean;
    readonly canChangeSvgColors: boolean;
    readonly canMaskImages: boolean;
    readonly colorID: number;
    readonly disableSellerImages: boolean;
    readonly fillColor: string | null;
    readonly maxNrImages: number | null;
    readonly maxNrShapes: number | null;
    readonly maxNrTexts: number | null;
    readonly modelID: number;
    readonly sideID: number;
  } | null> | null;
  readonly sidesPrintTypes: ReadonlyArray<{
    readonly colorID: number;
    readonly modelID: number;
    readonly printTypeID: number;
    readonly sideID: number;
  } | null> | null;
  readonly tags: ReadonlyArray<string | null> | null;
  readonly tempPreviewImageData: string | null;
  readonly tempPreviewImageUrl: string | null;
  readonly templateCode: string | null;
  readonly templateDesignID: number;
  readonly uploadRestrictions: {
    readonly isAiAllowed: boolean | null;
    readonly isEpsAllowed: boolean | null;
    readonly isFacebookAllowed: boolean | null;
    readonly isInstagramAllowed: boolean | null;
    readonly isJpgAllowed: boolean | null;
    readonly isPdfAllowed: boolean | null;
    readonly isPdfWithRasterAllowed: boolean | null;
    readonly isPngAllowed: boolean | null;
    readonly isSvgAllowed: boolean | null;
    readonly isUserImageAllowed: boolean | null;
    readonly resizeLargePdf: boolean | null;
  } | null;
  readonly visitorCode: string | null;
  readonly visitorID: number;
  readonly " $fragmentType": "composerQueriesTemplateDesign";
};
export type composerQueriesTemplateDesign$key = {
  readonly " $data"?: composerQueriesTemplateDesign$data;
  readonly " $fragmentSpreads": FragmentRefs<"composerQueriesTemplateDesign">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelID",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "printTypeID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAddText",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAddImage",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAddShape",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canMaskImages",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxNrTexts",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxNrImages",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxNrShapes",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canChangeSvgColors",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableSellerImages",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemID",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageID",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tag",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorID",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sideID",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "areaID",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shapeID",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rotation",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fillColor",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileObjectID",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modificationID",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "composerQueriesTemplateDesign",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "designID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentModificationID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compoundKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "docID",
      "storageKey": null
    },
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modelName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modelCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricingModelID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modelPriceDeltaPerc",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modelPriceDeltaValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modelPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modelTextBasePrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modelImageBasePrice",
      "storageKey": null
    },
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTemplate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLibrary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateDesignID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salesChannelID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compositionID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compositionDocID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finalPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interfaceID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "marketPlaceOrderID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tempPreviewImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tempPreviewImageData",
      "storageKey": null
    },
    (v4/*:: as any*/),
    (v5/*:: as any*/),
    (v6/*:: as any*/),
    (v7/*:: as any*/),
    (v8/*:: as any*/),
    (v9/*:: as any*/),
    (v10/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterCode",
      "storageKey": null
    },
    (v11/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UploadRestriction",
      "kind": "LinkedField",
      "name": "uploadRestrictions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUserImageAllowed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isJpgAllowed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPngAllowed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSvgAllowed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPdfAllowed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPdfWithRasterAllowed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEpsAllowed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAiAllowed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFacebookAllowed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInstagramAllowed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resizeLargePdf",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v12/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasSyncEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDraft",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adaptItemsToVariants",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentTemplateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdSettings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modifiedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modifiedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignItem",
      "kind": "LinkedField",
      "name": "designItems",
      "plural": true,
      "selections": [
        (v13/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemGuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "index",
          "storageKey": null
        },
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "svg",
          "storageKey": null
        },
        (v14/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageFormat",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageDpiX",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageDpiY",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageIsMulticolor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imagePreferredWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imagePreferredHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageFileSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageSellerID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageCustomerID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageCustomerCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageVisitorID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageVisitorCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imagePrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "applyImagePriceForQuantity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "providerImageID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemColors",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "syncGuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "overridePreview",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultLCID",
          "storageKey": null
        },
        (v15/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "designItemTagType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ColorMapping",
          "kind": "LinkedField",
          "name": "colorMappings",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "src",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dest",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignItemArea",
          "kind": "LinkedField",
          "name": "areas",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            (v16/*:: as any*/),
            (v17/*:: as any*/),
            (v18/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignItemColor",
          "kind": "LinkedField",
          "name": "colors",
          "plural": true,
          "selections": [
            (v19/*:: as any*/),
            (v14/*:: as any*/),
            (v16/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "colorCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignItemConstraints",
          "kind": "LinkedField",
          "name": "constraints",
          "plural": false,
          "selections": [
            (v13/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canMove",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canRotate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canResize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canDelete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canEdit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "keepNrChars",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minNrChars",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxNrChars",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paddingTypeID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paddingString",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeFontFamily",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeFontSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeFontColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeFontWeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeFontItalic",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeTextPathMode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeJustification",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canTransform",
              "storageKey": null
            },
            (v11/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAlwaysOnTop",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAlwaysOnBottom",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isPrintable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "keepInPreview",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mandatoryToEdit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canSyncContent",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canSyncAlignment",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canSyncFontFamily",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canSyncFontStyle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canSyncFontColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canSyncCurved",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canSyncTransforms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canResizeTextBox",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeTextBoxMode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "toUppercase",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canAddMask",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canReplaceMask",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canEditMask",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canDeleteMask",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canEditMaskedImage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeMaskStrokeColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeMaskStrokeWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canFillShape",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canReplaceShapeFilling",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canEditShapeFilling",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canDeleteShapeFilling",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canEditFilledShape",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeShapeStrokeColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeShapeStrokeWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeShapeFillColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeLetterSpacing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minLetterSpacing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxLetterSpacing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeLineSpacing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minLineSpacing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxLineSpacing",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeAdaptText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canWrapTextOnAdaptText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minFontSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxFontSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeVerticalAlignment",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeShadowColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeShadowBlur",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeShadowDistance",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeShadowAngle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minShadowBlur",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxShadowBlur",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minShadowDistance",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxShadowDistance",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minShadowAngle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxShadowAngle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeTextStrokeColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canChangeTextStrokeWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minTextStrokeWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxTextStrokeWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canStretch",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignItemTextArt",
          "kind": "LinkedField",
          "name": "textArt",
          "plural": false,
          "selections": [
            (v13/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fontFamilyID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fontFaceID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "textArtTypeID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TextArtConfig",
              "kind": "LinkedField",
              "name": "config",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "angleValue",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "curveValue",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "intensT",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "intensB",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isTriangle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isBridge",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isTop",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isBottom",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isMiddle",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignItemShape",
          "kind": "LinkedField",
          "name": "shape",
          "plural": false,
          "selections": [
            (v13/*:: as any*/),
            (v20/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMask",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignItemPatternSettings",
          "kind": "LinkedField",
          "name": "patternSettings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "offsetX",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "offsetY",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "spacingX",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "spacingY",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bounds",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "repeatX",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "repeatY",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "presetID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "flipX",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "flipY",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "offsetType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignItemFillGradientSettings",
          "kind": "LinkedField",
          "name": "fillGradientSettings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "gradientStops",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "gradientColors",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "radial",
              "storageKey": null
            },
            (v21/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "radius",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "centerX",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "centerY",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignItemFillImageSettings",
          "kind": "LinkedField",
          "name": "fillImageSettings",
          "plural": false,
          "selections": [
            (v14/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "topPosition",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "leftPosition",
              "storageKey": null
            },
            (v21/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "syncRatio",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "scaling",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "scalingX",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "scalingY",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "horizontalFlip",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "verticalFlip",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignSide",
      "kind": "LinkedField",
      "name": "sides",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        (v16/*:: as any*/),
        (v17/*:: as any*/),
        (v22/*:: as any*/),
        (v4/*:: as any*/),
        (v5/*:: as any*/),
        (v6/*:: as any*/),
        (v7/*:: as any*/),
        (v8/*:: as any*/),
        (v9/*:: as any*/),
        (v10/*:: as any*/),
        (v11/*:: as any*/),
        (v12/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignArea",
      "kind": "LinkedField",
      "name": "areas",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        (v16/*:: as any*/),
        (v17/*:: as any*/),
        (v18/*:: as any*/),
        (v2/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignAreaGrid",
      "kind": "LinkedField",
      "name": "areasGrids",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        (v16/*:: as any*/),
        (v17/*:: as any*/),
        (v18/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gridID",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignCanvasRotation",
      "kind": "LinkedField",
      "name": "canvasRotation",
      "plural": true,
      "selections": [
        (v17/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "degrees",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignTemplateColor",
      "kind": "LinkedField",
      "name": "colors",
      "plural": true,
      "selections": [
        (v16/*:: as any*/),
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isDefault",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignTemplateCategory",
      "kind": "LinkedField",
      "name": "categories",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryID",
          "storageKey": null
        },
        (v3/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignClientPreview",
      "kind": "LinkedField",
      "name": "clientPreviews",
      "plural": true,
      "selections": [
        (v17/*:: as any*/),
        (v23/*:: as any*/),
        (v24/*:: as any*/),
        (v3/*:: as any*/),
        (v25/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignCameraScreenshot",
      "kind": "LinkedField",
      "name": "cameraScreenshots",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cameraLocationID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cameraName",
          "storageKey": null
        },
        (v17/*:: as any*/),
        (v23/*:: as any*/),
        (v24/*:: as any*/),
        (v25/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignTempPreview",
      "kind": "LinkedField",
      "name": "designTempPreviews",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "designTempPreviewID",
          "storageKey": null
        },
        (v23/*:: as any*/),
        (v24/*:: as any*/),
        (v25/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignVariantCache",
      "kind": "LinkedField",
      "name": "designVariantCaches",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "previewFileObjectID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "designFileObjectID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "previewUrl",
          "storageKey": null
        },
        (v16/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignMoq",
      "kind": "LinkedField",
      "name": "moqs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minQuantity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quantityStep",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quantityPackages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rulesType",
          "storageKey": null
        },
        (v25/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Modification",
      "kind": "LinkedField",
      "name": "modifications",
      "plural": true,
      "selections": [
        (v25/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "modelColorID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "designElementsDescID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variantNotMatched",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SelectedAdditionalAttributes",
      "kind": "LinkedField",
      "name": "additionalAttributes",
      "plural": true,
      "selections": [
        (v3/*:: as any*/),
        (v26/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "price",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "KeyValuePairOfStringAndString",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": true,
          "selections": [
            (v19/*:: as any*/),
            (v26/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignElementsDesc",
      "kind": "LinkedField",
      "name": "elementsDescs",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignElement",
          "kind": "LinkedField",
          "name": "elements",
          "plural": true,
          "selections": [
            (v15/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TextDesignElement",
              "kind": "LinkedField",
              "name": "text",
              "plural": false,
              "selections": [
                (v27/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "strokeColor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "strokeWidth",
                  "storageKey": null
                },
                (v22/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fontFamily",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fontSize",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fontWeight",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fontStyle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fontStretch",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "justification",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "adaptText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "letterSpacing",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lineSpacing",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "verticalAlignment",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shadowColor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shadowBlur",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shadowDistance",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shadowAngle",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TextArtDesignElement",
              "kind": "LinkedField",
              "name": "textArt",
              "plural": false,
              "selections": [
                (v27/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageDesignElement",
              "kind": "LinkedField",
              "name": "image",
              "plural": false,
              "selections": [
                (v14/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ShapeDesignElement",
              "kind": "LinkedField",
              "name": "shape",
              "plural": false,
              "selections": [
                (v20/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignSidePrintType",
      "kind": "LinkedField",
      "name": "sidesPrintTypes",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        (v16/*:: as any*/),
        (v17/*:: as any*/),
        (v2/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        (v16/*:: as any*/),
        (v17/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "columns",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rows",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Design",
  "abstractKey": null
};
})();

(node as any).hash = "df7afa9f95e43f43adf65ad113f1609a";

export default node;
